import { createSelector } from 'reselect'
import * as R from 'ramda'

import {
  isClientSelector,
} from 'containers/Role/Global/selectors'

import {
  entitySelector,
  resultsSelector
} from 'containers/Entity/selectors'

const detailSelector = state => state.project.detail
const textSelector = state => state.project.HulkRequest.text
const licenseSelector = state => state.project.HulkRequest.license
const toggleSelector = state => state.project.HulkRequest.toggle
const hintSelector = state => state.project.HulkRequest.hint

const getDetailProperty = R.curry((prop, details) => details ? details[prop] : undefined)



const entitySelectorFunc = (entities, {type, id}) => {
  return type && id
    ? entities[type][id]
    : undefined
}

const projectDetailsSelector = createSelector(
  entitySelector,
  detailSelector,
  entitySelectorFunc
)

const projectIdSelector = createSelector(
  projectDetailsSelector,
  getDetailProperty('id')
)

export {
  projectIdSelector,
  textSelector,
  licenseSelector,
  toggleSelector,
  hintSelector
}


